module.exports = __webpack_public_path__ + "img/20200609_113913.4b316dd7.jpg";